import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LabSupplyList from './LabSupplyList';
import { fetchLabSupplies, deleteLabSupply } from '../../../ReduxSlices/LabSupplies/labSupplySlice';
import LoadingDots from '../../shared/LoadingDots';

const LabSupplySection = ({ navigateTo }) => {
  const dispatch = useDispatch();
  const { labSupplies, loading, fetched } = useSelector((state) => state.labSupplies);
  const [currentUser, setCurrentUser] = useState(null);
  const [deletingId, setDeletingId] = useState(null);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('currentUser'));
    setCurrentUser(storedUser);
  }, []);

  useEffect(() => {
    if (!fetched && !loading) {
      dispatch(fetchLabSupplies());
    }
  }, [dispatch, fetched, loading]);

  const handleDelete = async (id, name) => {
    if (window.confirm(`Delete ${name}? This action cannot be undone.`)) {
      setDeletingId(id);
      try {
        await dispatch(deleteLabSupply(id)).unwrap();
      } catch {
        // error handled by slice
      } finally {
        setDeletingId(null);
      }
    }
  };

  const handleEdit = (item) => {
    navigateTo('add_lab_supply', { editingItem: item });
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div className="flex text-[12px] text-gray-600 mt-2">
          <span className="mr-4">⛔ Expired</span>
          <span className="mr-4">⚠️ Low Stock</span>
        </div>
        {currentUser?.role === 'lab_technician' && (
          <button
            onClick={() => navigateTo('add_lab_supply')}
            type="button"
            className="primary"
          >
            + Add Supply
          </button>
        )}
      </div>

      {loading ? (
        <LoadingDots height={10} width={30} color="#38AD3E" />
      ) : labSupplies.length === 0 ? (
        <p className="text-center text-gray-500 mt-8">No supplies found.</p>
      ) : (
        <LabSupplyList
          labSupplies={labSupplies}
          onEdit={handleEdit}
          onDelete={handleDelete}
          currentUser={currentUser}
          deletingId={deletingId}
        />
      )}
    </div>
  );
};

export default LabSupplySection;
